module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABuwAAAbsBOuzj4gAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABWSURBVEiJY2QoOvafgYaAiZaGj1pAFGCBMY7k6DBYK/JSxdCj9z8z2Ey5wsDAgOQDFmZGqhjOwMDAwIwULoyjyXTALRhNRQTB0I/k0VSEFYymohFmAQB5ixs2VH/O4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/image/hamburger.png
// module id = 127
// module chunks = 0